exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fb-messenger-checkbox{width:200px!important}.fb-messenger-checkbox span{width:199px!important}@media (max-width:900px){.fb-messenger-checkbox{margin-left:35%!important}.fb-messenger-checkbox span{width:100%!important;height:55px!important}}@media (max-width:799px){.fb-messenger-checkbox{margin-left:-5%!important}}@media (max-width:435px){.fb-messenger-checkbox{width:200px!important}}@media (max-width:325px){.fb-messenger-checkbox{width:161px!important}}@media (max-width:300px){.fb-messenger-checkbox{width:180px!important}}@keyframes blink{50%{border-color:#fff}}", ""]);

// exports
